import React, { useState, useEffect } from "react";
import useApi from "../../hooks/useApi";
import { CSVLink } from "react-csv";
import { Form, Row, Col } from "react-bootstrap";
import Table from "react-bootstrap/Table";
import Select from "react-select";

export const ClientReport = () => {
  const { api, auth } = useApi();
  const [dropDowns, setDropDowns] = useState({});
  const [filter, setFilter] = useState({});
  const [report, setReport] = useState([]);

  const getDropDowns = async (models) => {
    try {
      const { data } = await api.list(`/dropdowns`, models);
      setDropDowns(data);
    } catch (error) {
      console.error(error);
    }
  };

  const onGenerateReport = async (e) => {
    e.preventDefault();
    try {
      const filterData = {
        ...filter,
        ClientId: filter?.ClientId?.value || "",
        relationManager: filter?.relationManager?.value || "",
      };
      const url = `/reports/client`;
      const { data } = await api.getAll(url, filterData, true);
      setReport(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getDropDowns(["client", "user"]);
  }, [auth]);

  useEffect(() => {
    if (dropDowns && filter) {
      setFilter({
        ...filter,
        ClientId:
          dropDowns?.client?.find(
            (client) => client.value === filter.ClientId
          ) || "",
      });
    }
  }, [dropDowns]);

  const headers = [
    { label: "Name", key: "name" },
    { label: "Email", key: "email" },
    { label: "Phone Number", key: "fullPhonenumber" },
    { label: "Address", key: "address" },
    { label: "Client Type", key: "client_type" },
    { label: "Contact Person", key: "contact_person" },
    { label: "Relationship Manager", key: "RelationManager.name" },
  ];

  const csvReport = {
    data: report,
    headers: headers,
    filename: "clients_report.csv",
  };

  return (
    <>
      <Form
        onSubmit={onGenerateReport}
        autoComplete="off"
        id="filterForm"
        className="mb-3"
      >
        <div className="card h-100">
          <fieldset>
            <div className="card-body">
              <div>
                <Row className="mb-3">
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">
                        Relationship Manager
                      </Form.Label>
                      <Select
                        id="relationManager"
                        options={
                          dropDowns && dropDowns["user"]
                            ? dropDowns["user"]
                            : []
                        }
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            relationManager: selectedOption,
                          })
                        }
                        value={filter?.relationManager || ""}
                      />
                    </Form.Group>
                  </Col>
                  <Col sm={12} md={6}>
                    <Form.Group>
                      <Form.Label className="text-primary">Client</Form.Label>
                      <Select
                        id="client"
                        options={
                          dropDowns && dropDowns["client"]
                            ? dropDowns["client"]
                            : []
                        }
                        onChange={(selectedOption) =>
                          setFilter({
                            ...filter,
                            ClientId: selectedOption,
                          })
                        }
                        value={filter?.ClientId || ""}
                      />
                    </Form.Group>
                  </Col>
                </Row>
              </div>
            </div>
          </fieldset>
          <div className="card-footer">
            <div className="d-flex justify-content-between">
              <button className={"btn btn-primary"} type="submit">
                Generate Report
              </button>
            </div>
          </div>
        </div>
      </Form>
      {report?.length > 0 && (
        <div className="card h-100">
          <div className="card-header">
            <h1>Report</h1>
          </div>
          <div className="card-body">
            <CSVLink {...csvReport}>Export to CSV</CSVLink>
            <Table striped bordered hover>
              <thead>
                <tr>
                  <td>Name</td>
                  <td>Email</td>
                  <td>Phone Number</td>
                  <td>Address</td>
                  <td>Client Type</td>
                  <td>Contact Person</td>
                  <td>Relationship Manager</td>
                </tr>
              </thead>
              <tbody>
                {report.map((element) => (
                  <tr key={element.id}>
                    <td>{element?.name}</td>
                    <td>{element?.email}</td>
                    <td>{element?.phonenumber}</td>
                    <td>{element?.address}</td>
                    <td>{element?.client_type}</td>
                    <td>{element?.contact_person}</td>
                    <td>{element?.RelationManager?.name || ""}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </div>
      )}
    </>
  );
};
